// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import CurrentDayForecasting from "./CurrentDayForecasting.js";

var dashboardCommonJS = require("../../js/dashboardCommon.js");

// Función del router
const DayForecasting = (params) => {    

    useEffect(() => {                 
      console.log("Detalle forecasting semanal METEO cargado correctamente.")
    }, [params]);

      const listDayForecasting = params.objDayForecasting.Data.map((timeframe,index) =>

        <React.Fragment key={timeframe.Timeframe}>
          <li className="horizontal gap-03 start">
            <figure className="avatar size-l"><img id={"iconoTiempoDiaCompleto"+timeframe.Timeframe+index} src={"https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+timeframe.SkyStatusValue+".png"} alt="Icono Tiempo" onError={() => document.getElementById("iconoTiempoDiaCompleto"+timeframe.Timeframe+index).src = "/img/unknownWeather.png"}/></figure>
            <dl className="vertical fill">
              <dt id={"etiquetaDayForecasting"+timeframe.Timeframe} className="size-xs clarification">De {timeframe.Timeframe.split("-")[0]+":00 h a "+timeframe.Timeframe.split("-")[1]+":00 h"}</dt>              
              <dd id={"valorDayForecasting"+timeframe.Timeframe} className="size-l"> {timeframe.SkyStatus}</dd>
              <dd id={"valorDayForecasting"+timeframe.Timeframe} className="size-l"> {timeframe.Temperature}ºC</dd>
            </dl> 
          </li>                
        </React.Fragment>        
     
      );    

      return (
        <>

          <details className="accordion">
            <summary className="title">
              <figure className="avatar size-l"><img id="iconoTiempo" src={
                params.objDayForecasting.OverallDayWeather.SkyStatusValue !== "" ?
                "https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+params.objDayForecasting.OverallDayWeather.SkyStatusValue+".png"
                : document.getElementById("iconoTiempoDashboard").src
                } alt="Icono Tiempo"/></figure>            
              <div className="vertical">
                <span className="size-s clarification">{dashboardCommonJS.formatearAFechaCorta(params.objDayForecasting.Datetime)} - {dashboardCommonJS.obtenerDiaDeLaSemana(params.objDayForecasting.Datetime)} {dashboardCommonJS.comprobarHoy(params.objDayForecasting.Datetime) ? "(Hoy)" : ""}</span>              
                <span className="size-l">{params.objDayForecasting.OverallDayWeather.SkyStatus}</span>              
              </div>
            </summary>

            <ul className="vertical gap-02">
              {dashboardCommonJS.comprobarHoy(params.objDayForecasting.Datetime) ?
              <CurrentDayForecasting objDayForecasting={params.objDayForecasting.Data}/>
              : listDayForecasting
              }  
            </ul>
          </details>
        </>
      )

}

export default DayForecasting